import storage from '../lib/storage';
import configureStore from './configure-store';

import sessionReducer from '../reducers/session.reducer';
import usersReducer from '../reducers/users.reducer';
import { AUTHENTICATE_USER } from '../actions/index';
import detectLanguage from '../lib/detect-language';

let sessionState = {
  language: detectLanguage(),
};
let initialState = {
  session: sessionState,
};
const auth = storage.getItem('auth');

if (auth) {
  const action = { type: AUTHENTICATE_USER, payload: auth };

  initialState = {
    users: usersReducer({}, action),
    session: sessionReducer(sessionState, action),
  };
}

export default configureStore(initialState);



// WEBPACK FOOTER //
// ./src/store/index.js